import React from 'react';
import './AboutUs.css';
import Seo from '../components/Seo/Seo';
import AboutUsHero from '../data/AboutUs/AboutUsHero';
import AboutUsFactSection from '../data/AboutUs/AboutUsFactSection';
import CompactAboutUsSection from '../data/AboutUs/CompactAboutUsSection';
import OurMissionSection from '../data/AboutUs/OurMissionSection';
import CEOSection from '../data/AboutUs/CeoSection';
import ContactReference from '../components/ProjectRequestSection/ProjectRequestSection';
import CodeTerminalSection from '../data/Home/CodeTerminalSection';

const aboutUsCodeLines = [
  { text: 'const team = new Nexite({', indent: 0 },
  { text: 'gegründet: 2018,', indent: 1 },
  { text: 'sitz: "Köln / Bonn",', indent: 1 },
  { text: 'mitglieder: 7,', indent: 1 },
  { text: '});', indent: 0 },
];

const AboutUs = () => {
  return (
    <>
      <Seo
        title="Über uns – Nexite IT | Digitalagentur aus Köln"
        description="Lernen Sie Nexite IT kennen: Ihre Agentur für Webentwicklung, App-Entwicklung und UI/UX Design im Raum Köln/Bonn."
        path="/ueber-uns"
      />

      <AboutUsHero />
      <AboutUsFactSection />
      <CompactAboutUsSection />
      <OurMissionSection />
      <CodeTerminalSection
        title="Senior-Expertise ohne Agentur-Overhead"
        highlight="ohne Agentur-Overhead"
        description="Schluss mit teuren Junior-Entwicklern und unendlichen Abstimmungsschleifen. Wir sind ein eingespieltes Kern-Team aus IT- und Business-Experten, das seit über 6 Jahren nahtlos zusammenarbeitet. Für Ihr Projekt bündeln wir punktgenau die nötigen Senior-Kompetenzen – vom MVP bis zur skalierbaren Enterprise-Plattform. Sie zahlen keine aufgeblähte Agentur-Infrastruktur, sondern pure, praxiserprobte Umsetzungskraft, die Ihre Prozesse automatisiert und messbares Wachstum antreibt."
        bullets={[
          'Feste Senior-Entwickler statt wechselnder Junioren',
          'Sofortiger Projektstart ohne Onboarding-Verzögerung',
          '100% maßgeschneidert & skalierbar für Ihr Budget',
        ]}
        ctaText="Projekt-Potenzial analysieren"
        ctaLink="/projektanfrage"
        fileName="team.js"
        codeLines={aboutUsCodeLines}
      />
      <CEOSection />
      <ContactReference />
    </>
  );
};

export default AboutUs;
